import { render, staticRenderFns } from "./ServiceEntityList.vue?vue&type=template&id=2ea897dd&"
import script from "./ServiceEntityList.vue?vue&type=script&lang=js&"
export * from "./ServiceEntityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports